module.exports = __webpack_public_path__ + "img/មាន់ជល់ខ្មែរ.9594a8e8.png";